import { LoadState } from "../../constants/enums";
import {
  IFoodeMenuCategoryState,
  IFoodItem,
  IMasterFoodMenu,
  IFoodMenuCategory,
  IFoodState,
  ILeadFoodMenu,
} from "./food.types";

export const initialFoodMenu: IMasterFoodMenu = {
  master_menu_uuid: null,
  title: "",
  description: "",
  menu_json: [],
  company_outlet_uuid: null,
  status: "ACTIVE",
  added_lead_menu_uuid: null,
};

export const initialFoodItem: IFoodItem = {
  food_item_uuid: null,
  item_name: "",
  company_outlet_uuid: "",
  type: "",
  item_description: "",
  status: "ACTIVE",
};

export const initialLeadFoodMenu: ILeadFoodMenu = {
  added_lead_menu_uuid: null,
  leads_uuid: null,
  title: "",
  description: "",
  menu_json: [],
  company_outlet_uuid: null,
  status: "ACTIVE",
};

export const initialFoodState: IFoodState = {
  foodMenu: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
    totalRecords: 0,
  },
  foodItem: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
    totalRecords: 0,
  },
  leadFoodMenu: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
  foodCategory: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
};

export const initialCategory: IFoodMenuCategory = {
  category_unique_id: 0,
  category_uuid: "",
  category_name: "",
  category_description: "",
  company_outlet_uuid: "",
  status: "ACTIVE",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: null,
  modified_by_name: null,
  create_ts: "",
  insert_ts: "",
  food_items: [],
};

export const initialFoodMenuCategoryState: IFoodeMenuCategoryState = {
  categoryList: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
};
